export class NewTreatmentPlanRequestModel {
  PatientId: string;
  ParentTreatmentPlanningId: string;
  IsCreateBlankProcedure: boolean;

  constructor(patientId: string, parentTreatmentPlanningId: string, isCreateBlankProcedure) {
    this.PatientId = patientId;
    this.ParentTreatmentPlanningId = parentTreatmentPlanningId;
    this.IsCreateBlankProcedure = isCreateBlankProcedure;
  }
}
